// For form type
export const FORM_TYPE = {
    CONTACT: 'Formulaire de contact',
    MEETING: 'Formulaire de rendez-vous',
    SIMULATOR: 'Simulateur',
}
